import Card from "../../components/Card/Card";
import axios from "axios";
import React from "react";

import Categories from "../../components/Categories/Categories";
import CatDropdown from "../../components/Categories/CatDropdown";
import AmountBar from "../../components/Card/AmountBar";


// const idAlpha = "003b3c47-204e-11f0-0a80-19c70012b504";
const idAlpha = "91a131c2-2a72-11f0-0a80-03da000e0fda";
const AlphaOrderIndex = 3;


function Glicerin12Extra({ cart, forceUpdate, activeCategory = 0 }) {
	const [loadedData, setLoadedData] = React.useState({ products: [], size: 0 });
	const [whichActive, setWhichActive] = React.useState(activeCategory);


	let isDesktop = window.screen.orientation.type.includes("landscape");

	React.useEffect(() => {
		// deprecates requests, if data up to date already
		if (loadedData.size) return;
		
		axios.get("/get_glicerin_12")
			.then(res => {
				setLoadedData(res.data);
				console.log(`data set to: ${res.data}`);
			});
	});
	React.useEffect(() => {
		console.log('which acive set to', whichActive)
	}, [whichActive]);

	let quantity = loadedData.size,
		prod = loadedData.products;

	let cards = new Array();
	let body = new Array();

	let lastCategory = null;
	let lastParams = { title: "&hidden", className: "", id: "", isActive: false };

	prod.filter(p => { return p.id !== AlphaOrderIndex })
		.map((product, i) => {
			if (product.category !== lastCategory) {
				if (!lastCategory) {
					lastCategory = product.categoryId;
				}

				let newDD = <CatDropdown
					className={lastParams.className}
					id={lastParams.id}
					title={lastParams.title}
					cards={[...cards]}
					isActive={lastParams.isActive} 
				/>

				body.push(newDD);
				cards = [];

				if (product.categoryId === "2ce4d356-b209-11ee-0a80-032d001d7154") {
					let title = (
						<span>SWEETS & DESSERTS</span>
					);
					lastParams = { title: title, className: "_rose", id: "sec3", isActive: true };
				}
				else if (product.categoryId === "c3f08641-b0c4-11ee-0a80-0ea30001ed85") {
					let title = (
						<span>FRUITS & DRINKS</span>
					);
					lastParams = { title: title, className: "_orange", id: "sec1", isActive: true };
				}
				else if (product.categoryId === "ab22539f-b5f6-11ee-0a80-05fc0027a1a3") {
					let title = (
						<span>ICE EDITIONS</span>
					);
					lastParams = { title: title, className: "_blue", id: "sec2", isActive: true };
				}
			}

		let quantity = 0;
		if (Object.keys(cart.stored).includes(product.code))
			quantity = cart.stored[product.code].quantity;

		let new_card = (
			<Card
				className="taste__card"
				title={product.name}
				subtitle={product.description}
				price={product.price}
				cardSrc={product.imageURLMiniature}
				item={product}
				cart={cart}
				forceUpdate={forceUpdate}
				quantity={quantity}
			/>
		);
		cards.push(new_card);
		lastCategory = product.category;
	});
	let newDD = <CatDropdown
		className={lastParams.className}
		id={lastParams.id}
		title={lastParams.title}
		cards={[...cards]}
		isActive={lastParams.isActive} />
	body.push(newDD);
	cards = [];

	return (
		<>
			<h1 className="title">
				{
					whichActive === AlphaOrderIndex
						? <> Alpha <span> for PODS </span> </>
						: <>Премiкс 12 мл <span>EXTRA/SALT</span></>
				}

			</h1>
			<div className="all-goods _mob">
				<span>{quantity}</span> товарів
			</div>

			<AmountBar cart={cart} />

			<div className="taste-wrapper">

				{/* 
					Не убирать. Здесь якоря для разделов продукции, которые позже могут вернуть
				*/}

				{/*<div className="subcategory-catalog">
					<div className="subcategory-catalog__content">
						<a onClick={() => setWhichActive(3)}>
							<div className={whichActive === 3 ? ("subcategory-catalog__item _active") : ("subcategory-catalog__item")}>
								ALPHA
							</div>
						</a>
						<a href="#sec1">
							<div className={!whichActive ? ("subcategory-catalog__item _active") : ("subcategory-catalog__item")}
								onClick={() => setWhichActive(0)}>
								FRUITS & DRINKS</div>
						</a>
						<a href="#sec2">
							<div className={whichActive === 1 ? ("subcategory-catalog__item _active") : ("subcategory-catalog__item")}
								onClick={() => setWhichActive(1)}>
								ICE EDITIONS</div>
						</a>
						<a href="#sec3">
							<div className={whichActive === 2 ? ("subcategory-catalog__item _active") : ("subcategory-catalog__item")}
								onClick={() => setWhichActive(2)}>
								SWEETS & DESSERTS
							</div>
						</a>
					</div>
				</div>*/}

				<section className="taste">
					<div className="taste__body">
						{
							whichActive === AlphaOrderIndex
								? <div className="">
									{loadedData.products
										.filter(product => { 
											return product.categoryId === idAlpha 
										})
										.map((product, i) => {
											let quantity = 0;
											if (Object.keys(cart.stored).includes(product.code))
												quantity = cart.stored[product.code].quantity;
											
											return (
												<div className="" key={i}>
													<Card
														className="taste__card"
														title={product.name}
														subtitle={product.description}
														price={product.price}
														cardSrc={product.imageURLMiniature}
														item={product}
														cart={cart}
														forceUpdate={forceUpdate}
														quantity={quantity}
													/>
												</div>
											);
										})
									}
								</div>

								: body
						}
					</div>
				</section>
			</div>
		</>
	);
}

export default Glicerin12Extra;
